import React from 'react';
import Header from './src/components/Header';
import { StoreProvider } from './src/context/StoreContext';

export const wrapRootElement = ({ element }) => (
  <StoreProvider>{element}</StoreProvider>
);

export const wrapPageElement = ({ element }) => <>{element}</>;
